import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import CastingCommon from '@utils/casting-common';

import ProjectPostContentsModal from '@project/modal/post-contents-modal/_post-contents-modal';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------


class InfluencerStatus extends React.Component {
  updateStatus(update) {
    let detail = this.props.detail;
    
    Utils.request.bind(this)('/api/project/influencer/status_update', { project_id: detail.project_id, insta_user_id: detail.insta_user_id, update: update },
      function(res){
        this.props.base.event.updateData('workflow', res.body.workflow);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let detail = this.props.detail;
    
    // 入力アイテムリスト
    let items = [
      { id: 'progress',       name: 'ステータス',     html: <ItemStatus /> },
      { id: 'post_contents',  name: '投稿種別',       html: <ItemPostContents detail={detail} /> },
      { id: 'contract_money', name: '報酬',           html: <ItemContractMoney />,  default: detail.workflow_status.contract_money, place_holder: '金額を入力してください' },
      { id: 'posting_date',   name: '投稿予定日',     html: <ItemInput type="datetime-local" />,  default: Utils.setDate(detail.workflow_status.posting_date, 'YYYY-MM-DD HH:mm') },
      //{ id: 'option_setting', name: 'ステータス操作', html: <OptionSetting detail={detail} /> },
    ];
    
    let progress_status = CastingCommon.getProgressStatus(detail.workflow.progress, detail.workflow_groups.list, detail.workflow.is_ng);
    
    return (
      <div className="influencer-contents-status-edit">
        { items.map((d, key) => {
          let _html = React.cloneElement(d.html, { key: key, data: d, detail: detail, base: this.props.base, update_ev: this.updateStatus.bind(this), refresh_ev: this.props.refresh_ev.bind(this) })
          return _html;
        })}
      </div>
    );
  }
}
// -------------------------------------------------------

class ItemStatus extends React.Component {
  update() {
    this.props.update_ev.bind(this)({ column: this.props.data.id, value: this.item.value });
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let detail = this.props.detail;
    
    // ステータスリスト
    let statusList = detail.workflow_groups.list.concat();
    if( detail.workflow.is_ng == 1 ) statusList.push({ id: 'is_ng', name: 'アサインNG' });
    
    // ステータス初期値
    let statusDefault = detail.workflow.progress;
    if( detail.workflow.is_ng == 1 ) statusDefault = 'is_ng';
    
    return (
      <div className="status-item status-item-select">
        <h6>{data.name}</h6>
        <div className="selectbox">
          <select ref={(input) => { this.item = input }} onChange={this.update.bind(this)} defaultValue={statusDefault}>
            { statusList.map((d, key) => {
              return <option key={key} value={d.id}>{d.name}</option>
             })}
          </select>
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

class ItemInput extends React.Component {
  update() {
    this.props.update_ev.bind(this)({ column: this.props.data.id, value: this.item.value });
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    
    return (
      <div className="status-item status-item-input">
        <h6>{data.name}</h6>
        <input className="text" type={this.props.type} ref={(input) => { this.item = input }} onBlur={this.update.bind(this)} defaultValue={data.default} placeholder={data.place_holder} />
      </div>
    );
  }
}
// -------------------------------------------------------

class ItemContractMoney extends React.Component {
  update() {
    this.props.update_ev.bind(this)({ column: this.props.data.id, value: this.item.value });
  }
  // -------------------------------------------------------
  
  setAutoContractMoney() {
    let detail = this.props.detail;
    
    Utils.request.bind(this)('/api/project/influencer/auto_contract_money', { project_id: detail.project_id, insta_user_id: detail.insta_user_id, is_manual: true },
      function(res){
        let money = res.body.contract_money;
        
        let chk = confirm('自動で報酬を算出しました。\n金額は、「\\'+ Utils.viewInt(money) +'」になります。反映してもよろしいですか？');
        if( chk == false ) return;
        
        this.props.update_ev.bind(this)({ column: 'contract_money', value: money });
        
        this.item.value = money;
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let detail = this.props.detail;
    
    if( detail.workflow_status.is_entry == 1 ){
      return (
        <OverlayTrigger placement="left" delayShow={50} overlay={<Tooltip>既に金額を確定しています</Tooltip>}>
          <div className="status-item status-item-input">
            <h6>{data.name}</h6>
            <input className="text" ref={(input) => { this.item = input }} defaultValue={data.default} disabled={true} />
          </div>
        </OverlayTrigger>
      );
    }
    
    return (
      <div className="status-item status-item-input">
        <h6>{data.name}</h6>
        
        { (detail.workflow_post_contents.length > 0)
          ? <div className="after-button on" onClick={this.setAutoContractMoney.bind(this)}><i className="material-icons">attach_money</i>自動金額設定</div>
          : <OverlayTrigger placement="left" delayShow={50} overlay={<Tooltip>投稿種別を設定する必要があります</Tooltip>}>
              <div className="after-button off"><i className="material-icons">attach_money</i>自動金額設定</div>
            </OverlayTrigger>
        }
        
        <input className="text" ref={(input) => { this.item = input }} onBlur={this.update.bind(this)} defaultValue={data.default} placeholder={data.place_holder} />
      </div>
    );
  }
}
// -------------------------------------------------------

class ItemPostContents extends React.Component {
  update() {
    this.props.update_ev.bind(this)({ column: this.props.data.id, value: this.item.value });
  }
  // -------------------------------------------------------
  
  render() {
    let base = this.props.base;
    let data = this.props.data;
    let detail = this.props.detail;
    
    return (
      <div className="status-item status-item-post-contents">
        <h6>{data.name}</h6>
        
        { (detail.workflow_post_contents.length == 0)
          ? <div className="none">投稿種別を設定していません</div>
          : <ul>
              { detail.workflow_post_contents.map((d, key) => {
                return (
                  <li key={key}>
                    {d.name}
                  </li>
                );
              })}
            </ul>
        }
        
        { (base.event.showPostContents != undefined) &&
          <p className="edit-post-contents" onClick={base.event.showPostContents.bind(this, detail.project_id, detail.insta_user_id)}><i className="material-icons">edit</i></p>
        }
        
        <ProjectPostContentsModal data={base} project_id={detail.project_id} insta_user_id={detail.insta_user_id} refresh_ev={this.props.refresh_ev.bind(this)} />
      </div>
    );
  }
}
// -------------------------------------------------------

class OptionSetting extends React.Component {
  setNG() {
    let chk = confirm('ステータスをNGに変更してもよろしいですか？');
    if( chk == false ) return;
    
    this.props.update_ev.bind(this)({ column: 'is_ng', value: true });
  }
  // -------------------------------------------------------
  
  setEntry() {
    let chk = confirm('エントリー前の状態に変更してもよろしいですか？\n※インフルエンサーの操作に影響します。扱いにはご注意下さい。');
    if( chk == false ) return;
    
    this.props.update_ev.bind(this)({ column: 'is_entry', value: 0 });
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let detail = this.props.detail;
    
    return (
      <div className="status-item status-item-select">
        <h6>{data.name}</h6>
        <div className="option-setting">
          { (detail.workflow.is_ng == 0)
            ? <p className="button" onClick={this.setNG.bind(this)}>NGに変更する</p>
            : <p className="button off">NGに変更する</p>
          }
          { (detail.workflow_status.is_entry == 1)
            ? <p className="button" onClick={this.setEntry.bind(this)}>エントリー前に戻す</p>
            : <p className="button off">エントリー前に戻す</p>
          }
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InfluencerStatus;